import { createHookWithCallbacks } from '@move-frontend/auth';
import { resetPasswordWithCallbacks } from './resetPasswordWithCallbacks';

export const useResetPasswordWithCallbacks = createHookWithCallbacks(
	resetPasswordWithCallbacks,
);
